module.exports = __webpack_public_path__ + "static/media/11-srttk.30491097.png";